import * as React from "react";
import {
  ActivityFragment,
  CampaignMinimalFragment,
  CompanyMinimalFragment,
} from "../../../graphql/fragments";
import useTranslations from "../../../hooks/useTranslations";
import { timeAgoLabel } from "../../../utils/timeAgo";
import { BuildingIcon } from "../../icons";
import { Link } from "../../wombat-ui";
import { Span } from "../../wombat-ui/components/Typography";
import Activity from "../ActivityPlate";

interface CampaignUpdatedActivityProps {
  activity: CampaignUpdatedActivity;
}

type CampaignUpdatedActivity = ActivityFragment & {
  recipient: CompanyMinimalFragment;
  trackable: CampaignMinimalFragment;
};

export function isCampaignUpdatedActivity(
  q: ActivityFragment
): q is CampaignUpdatedActivity {
  return q.key === "campaign.updated";
}

interface CampaignUpdatedActivityProps {
  activity: CampaignUpdatedActivity;
}

export const CampaignUpdatedActivity: React.FC<CampaignUpdatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="campaignUpdatedActivity"
      visual={<BuildingIcon iconClassName="w-10 h-10 text-accent-500" />}
    >
      <Span className="text-sm">
        {t("activity.labels.campaignUpdated", {
          campaign: (
            <Link
              to={`/campaigns/${activity.trackable.slug}`}
              key={activity.id}
            >
              {t("activity.objects.campaign")}
            </Link>
          ),
        })}
      </Span>
    </Activity>
  );
};
